import React, { useState } from "react";
import { Table, Rate, Progress, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";

const { Text } = Typography;

interface TechnicianData {
  key: React.Key;
  technicianName: string;
  rating: number;
  totalCases: number;
  casesClosedPercent: number;
  avgClosingTime: number;
}

const CasesTable: React.FC = React.memo(() => {
  const columns: ColumnsType<TechnicianData> = [
    {
      title: "Technician Name",
      dataIndex: "technicianName",
      key: "technicianName",
      sorter: (a, b) => a.technicianName.localeCompare(b.technicianName),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      sorter: (a, b) => a.rating - b.rating,
      render: (rating: number) => (
        <Rate
          disabled
          defaultValue={rating}
          style={{ fontSize: 16, color: "#1F5782" }}
        />
      ),
    },
    {
      title: "Total Cases",
      dataIndex: "totalCases",
      key: "totalCases",
      sorter: (a, b) => a.totalCases - b.totalCases,
      render: (totalCases: number) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Progress
            percent={(totalCases / 700) * 100}
            showInfo={false}
            strokeColor="#1F5782"
            trailColor="#E0E0E0"
            strokeWidth={12}
            style={{ flex: 1 }}
          />
          <Text strong style={{ fontSize: 14 }}>
            {totalCases}
          </Text>
        </div>
      ),
    },
    {
      title: "% Cases Closed",
      dataIndex: "casesClosedPercent",
      key: "casesClosedPercent",
      sorter: (a, b) => a.casesClosedPercent - b.casesClosedPercent,
      render: (casesClosedPercent: number) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Progress
            percent={casesClosedPercent}
            showInfo={false}
            strokeColor="#1F5782"
            trailColor="#E0E0E0"
            strokeWidth={12}
            style={{ flex: 1 }}
          />
          <Text strong style={{ fontSize: 14 }}>
            {casesClosedPercent.toFixed(2)}%
          </Text>
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "right", width: "100%" }}>
          Avg Closing Time(Hrs)
        </div>
      ), // ✅ Right-aligned title
      dataIndex: "avgClosingTime",
      key: "avgClosingTime",
      align: "right",
      sorter: (a, b) => a.avgClosingTime - b.avgClosingTime,
      render: (time: number) => <Text strong>{time.toFixed(2)}</Text>,
    },
  ];

  const data: TechnicianData[] = [
    {
      key: 1,
      technicianName: "Dipak Kumar",
      rating: 5,
      totalCases: 609,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
    {
      key: 2,
      technicianName: "Eros Group",
      rating: 4,
      totalCases: 558,
      casesClosedPercent: 65.23,
      avgClosingTime: 53.77,
    },
    {
      key: 3,
      technicianName: "Gatikrushna Das",
      rating: 4.5,
      totalCases: 520,
      casesClosedPercent: 75.05,
      avgClosingTime: 53.77,
    },
    {
      key: 4,
      technicianName: "Manjula Kumara Nanayakkra",
      rating: 4.5,
      totalCases: 502,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
    {
      key: 5,
      technicianName: "Dipak Kumar",
      rating: 3,
      totalCases: 609,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
    {
      key: 6,
      technicianName: "Dipak Kumar",
      rating: 4,
      totalCases: 609,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
    {
      key: 7,
      technicianName: "Eros Group",
      rating: 4,
      totalCases: 558,
      casesClosedPercent: 65.23,
      avgClosingTime: 53.77,
    },
    {
      key: 8,
      technicianName: "Gatikrushna Das",
      rating: 4.5,
      totalCases: 520,
      casesClosedPercent: 75.05,
      avgClosingTime: 53.77,
    },
    {
      key: 9,
      technicianName: "Manjula Kumara Nanayakkra",
      rating: 4.5,
      totalCases: 502,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
    {
      key: 10,
      technicianName: "Dipak Kumar",
      rating: 3,
      totalCases: 609,
      casesClosedPercent: 52.05,
      avgClosingTime: 53.77,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={{
        current: currentPage,
        pageSize: 10,
        total: data.length,
        onChange: handlePageChange,
        showSizeChanger: false,
        style: { marginTop: 16, textAlign: "center" },
      }}
      scroll={{ x: "max-content" }}
      components={{
        header: {
          row: (rowProps: any) => (
            <tr {...rowProps} style={{ backgroundColor: "#F8F8F8" }} />
          ),
          cell: (cellProps: any) => (
            <th {...cellProps} style={{ backgroundColor: "#F8F8F8" }} />
          ),
        },
      }}
      style={{
        borderRadius: 8,
        overflow: "hidden",
        minWidth: "100%",
      }}
    />
  );
});

export default CasesTable;
